import { useCssModule, ref, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import { c as createAutofocusProp, u as useAutofocus } from "./assets/useAutofocus-CnLXEQZi.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useFullWidthProp } from "./assets/index-4vIud5LZ.js";
import { u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import { u as useValidationsProp } from "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./assets/index-BJV0_gaH.js";
import XFormField from "./XFormField.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Df_FM1j-.js";
import "./XLink.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
import "./XTooltip.js";
import "./assets/XDropdown-Bc_0Fycm.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
const textArea = "_textArea_1wntb_1";
const input = "_input_1wntb_12";
const hasError = "_hasError_1wntb_30";
const style0 = {
  textArea,
  input,
  hasError
};
const RESIZE_DIRECTIONS = ["both", "horizontal", "vertical", "none"];
const { createFullWidthProp } = useFullWidthProp();
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createValidationsProp } = useValidationsProp();
const { createVModelProp, setupVModel } = useVModel();
const {
  createMessageProps,
  createAdditionalMessagesProp,
  createLabelProps,
  createFormFieldProps,
  createInputProps,
  createRequiredProp
} = useInputProps();
const __default__ = {
  name: "XTextArea",
  components: { XFormField },
  inheritAttrs: false
};
const _sfc_main = Object.assign(__default__, {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    textAreaClasses: {
      type: Array,
      default: () => []
    },
    maxlength: {
      type: [String, Number],
      default: ""
    },
    minHeight: {
      type: String,
      default: "210px"
    },
    maxHeight: {
      type: String,
      default: null
    },
    resize: {
      type: String,
      default: "both",
      validator: (direction) => RESIZE_DIRECTIONS.includes(direction)
    },
    ...createMessageProps(),
    ...createAdditionalMessagesProp(),
    ...createValidationsProp(),
    ...createLabelProps(),
    ...createFormFieldProps(),
    ...createInputProps(),
    ...createRequiredProp(),
    ...createVModelProp(),
    ...createAutofocusProp(),
    ...createDisabledProp(),
    ...createFullWidthProp(),
    ...createTestIdProp()
  },
  emits: ["input", "keyup", "click", "blur", "update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const $style = useCssModule();
    const { inputRef } = useAutofocus(props);
    const { data: internalValue } = setupVModel(props, emit);
    const hasError2 = ref(null);
    const errorClass = computed(() => ({
      [$style.hasError]: hasError2.value
    }));
    const xTextAreaStyles = computed(() => ({
      maxHeight: props.maxHeight,
      minHeight: props.minHeight,
      resize: props.resize
    }));
    const maxHeightNumber = computed(() => parseInt(props.maxHeight, 10));
    function handleError(event) {
      hasError2.value = event;
    }
    function setHeightToFitContent(event) {
      const isLimitReached = props.maxHeight && event.target.scrollHeight >= maxHeightNumber.value;
      if (!isLimitReached) {
        inputRef.value.style.height = "auto";
        const hasScroll = event.target.scrollHeight > event.target.clientHeight;
        if (hasScroll) {
          const offset = event.target.offsetHeight - event.target.clientHeight;
          const newHeight = `${event.target.scrollHeight + offset}px`;
          inputRef.value.style.height = newHeight;
        }
      }
    }
    return { __sfc: true, RESIZE_DIRECTIONS, createFullWidthProp, createDisabledProp, createTestIdProp, setupTestId, createValidationsProp, createVModelProp, setupVModel, createMessageProps, createAdditionalMessagesProp, createLabelProps, createFormFieldProps, createInputProps, createRequiredProp, props, emit, formatTestId, $style, inputRef, internalValue, hasError: hasError2, errorClass, xTextAreaStyles, maxHeightNumber, handleError, setHeightToFitContent, XFormField };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XFormField, _vm._b({ class: _setup.$style.textArea, attrs: { "data-testid": _setup.formatTestId("field") }, on: { "error": _setup.handleError }, scopedSlots: _vm._u([{ key: "default", fn: function({ uuid }) {
    return [_c("textarea", { directives: [{ name: "model", rawName: "v-model", value: _setup.internalValue, expression: "internalValue" }], ref: "inputRef", class: [_setup.$style.input, _setup.errorClass, ..._vm.textAreaClasses], style: _setup.xTextAreaStyles, attrs: { "id": uuid, "name": _vm.name, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "maxlength": _vm.maxlength, "data-testid": _setup.formatTestId(), "autofocus": _vm.autofocus, "placeholder": _vm.placeholder }, domProps: { "value": _setup.internalValue }, on: { "input": [function($event) {
      if ($event.target.composing) return;
      _setup.internalValue = $event.target.value;
    }, _setup.setHeightToFitContent], "keyup": function($event) {
      return _vm.$emit("keyup", $event);
    }, "click": function($event) {
      return _vm.$emit("click", $event);
    }, "blur": function($event) {
      return _vm.$emit("blur", $event);
    } } })];
  } }]) }, "XFormField", { ..._vm.$props, ..._vm.$attrs }, false));
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTextArea = __component__.exports;
export {
  RESIZE_DIRECTIONS,
  XTextArea as default
};
